function readEnvNumber(name) {
  try {
    const raw = globalThis?.import?.meta?.env?.[name];
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function positiveInt(value, fallback) {
  if (!Number.isFinite(value)) return fallback;
  return Math.max(1, Math.floor(value));
}

export const REMOTE_INTERP_MIN_DELAY_MS = positiveInt(readEnvNumber("VITE_REMOTE_INTERP_MIN_DELAY_MS"), 55);
export const REMOTE_INTERP_MAX_DELAY_MS = positiveInt(readEnvNumber("VITE_REMOTE_INTERP_MAX_DELAY_MS"), 190);
export const REMOTE_INTERP_BASE_DELAY_MS = (() => {
  const raw = readEnvNumber("VITE_REMOTE_INTERP_BASE_DELAY_MS");
  if (!Number.isFinite(raw)) return null;
  return clamp(Math.floor(raw), REMOTE_INTERP_MIN_DELAY_MS, REMOTE_INTERP_MAX_DELAY_MS);
})();
export const REMOTE_MAX_EXTRAPOLATION_MS = positiveInt(readEnvNumber("VITE_REMOTE_MAX_EXTRAPOLATION_MS"), 220);
export const REMOTE_SNAP_DISTANCE_PX = (() => {
  const raw = readEnvNumber("VITE_REMOTE_SNAP_DISTANCE_PX");
  if (!Number.isFinite(raw)) return 260;
  return Math.max(64, raw);
})();
export const REMOTE_JITTER_WINDOW = (() => {
  const raw = readEnvNumber("VITE_REMOTE_JITTER_WINDOW");
  return clamp(positiveInt(raw, 24), 4, 120);
})();
export const REMOTE_JITTER_FACTOR = (() => {
  const raw = readEnvNumber("VITE_REMOTE_JITTER_FACTOR");
  if (!Number.isFinite(raw)) return 1.5;
  return clamp(raw, 0, 5);
})();
